import request from '@/utils/request'

// 查询字典数据列表
export function pageData(query) {
  console.log('=== pageData API 调用 ===')
  console.log('query 参数:', query)
  console.log('URL: /system/dict/data/page')
  console.log('期望完整 URL: /system/dict/data/page?dictType=' + (query.dictType || '') + '&pageNum=' + (query.pageNum || 1) + '&pageSize=' + (query.pageSize || 10))
  console.log('========================')
  
  // 确保参数对象存在且不为空
  const params = query || {}
  
  return request({
    url: '/system/dict/data/page',
    method: 'get',
    params: params,
  })
}
// 查询字典数据列表
export function listData(query) {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params: query,
  })
}

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'get',
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get',
  })
}

// 新增字典数据
export function addData(data) {
  return request({
    url: '/system/dict/data',
    method: 'post',
    data: data,
  })
}

// 修改字典数据
export function updateData(data) {
  return request({
    url: '/system/dict/data',
    method: 'put',
    data: data,
  })
}

// 删除字典数据
export function delData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'delete',
  })
}
